import React from 'react';

import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  getStateOptions,
  getTechJobDescriptions,
  getTechProfile,
} from 'registration/selectors';
import { OnboardingUpdates } from 'registration/types';

import OnboardingStep from './OnboardingStep';
import OnboardingStepController, {
  COMPLETE_ONBOARDING_STEP,
  GET_HIRED_STEP,
  PASSWORD_STEP,
  SIGNUP_STEP,
} from './OnboardingStepController';
import GetHired from './pages/GetHired';
import OnboardingFormEmail from './pages/OnboardingFormEmailCombined';
import OnboardingPassword from './pages/OnboardingFormPassword';
import OnboardingTechDetailsForm from './pages/OnboardingTechDetailsForm';
import RedirectPage from './pages/RedirectPage';

const ONBOARD_VARIANT = 'antz';
const SIGN_UP_STEP_LIST = [
  SIGNUP_STEP,
  PASSWORD_STEP,
  'detailsForm',
  GET_HIRED_STEP,
  COMPLETE_ONBOARDING_STEP,
];

const ONBOARD_STEP_LIST = [
  'detailsForm',
  GET_HIRED_STEP,
  COMPLETE_ONBOARDING_STEP,
];

type OnboardingFormProps = {
  serverTalentProfile?: Partial<OnboardingUpdates>;
};

const OnboardingForm = ({ serverTalentProfile = {} }: OnboardingFormProps) => {
  const { intent, type } = useParams();

  const getStepComponent = (step) => {
    let stepComponent;
    switch (step) {
      case 'detailsForm': {
        const keys = ['fullName', 'currentLocation', 'techRoleOptions'];

        stepComponent = (
          <OnboardingStep
            key="detailsForm"
            stepName="detailsForm"
            justifyFlexStart
          >
            <OnboardingTechDetailsForm
              pageTalentProfileKeys={keys}
              includeSignInLink={!serverTalentProfile.id}
            />
          </OnboardingStep>
        );
        break;
      }
      case SIGNUP_STEP:
        stepComponent = (
          <OnboardingStep
            key={SIGNUP_STEP}
            stepName={SIGNUP_STEP}
            justifyFlexStart
          >
            <OnboardingFormEmail profileType="tech" />
          </OnboardingStep>
        );
        break;
      case PASSWORD_STEP: {
        stepComponent = (
          <OnboardingStep
            key={PASSWORD_STEP}
            stepName={PASSWORD_STEP}
            justifyFlexStart
          >
            <OnboardingPassword profileType="tech" />
          </OnboardingStep>
        );
        break;
      }
      case GET_HIRED_STEP:
        stepComponent = (
          <OnboardingStep
            key={GET_HIRED_STEP}
            stepName={GET_HIRED_STEP}
            bodyClasses="onboarding-page get-hired-page"
            justifyFlexStart
          >
            <GetHired profileType="tech" />
          </OnboardingStep>
        );
        break;
      case COMPLETE_ONBOARDING_STEP:
        // TODO need to include redirects to tech specific pages
        stepComponent = <RedirectPage intent={intent} />;
        break;
      default:
        return null;
    }

    return stepComponent;
  };

  const defaultStepList =
    serverTalentProfile.id && type === 'onboard'
      ? ONBOARD_STEP_LIST
      : SIGN_UP_STEP_LIST;

  return (
    <OnboardingStepController
      defaultStepList={defaultStepList}
      getStepComponent={getStepComponent}
      intent={intent}
      variant={ONBOARD_VARIANT}
    />
  );
};

const mapStateToProps = (state) => ({
  serverTalentProfile: getTechProfile(state),
  stateOptions: getStateOptions(state),
  techJobDescriptions: getTechJobDescriptions(state),
});

export default connect(mapStateToProps)(OnboardingForm);
